/**
 * @author mschuetz / http://mschuetz.at
 *
 * adapted from THREE.OrbitControls by
 *
 * @author qiao / https://github.com/qiao
 * @author mrdoob / http://mrdoob.com
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author erich666 / http://erichaines.com
 *
 *
 *
 */

import * as THREE from "../../libs/three.js/build/three.module.js"; 
import {Utils} from "../utils.js"; 
 
const standartMinRadius = 2
window.camRatio = 1850

 
export class OrbitControls extends THREE.EventDispatcher{
	
	constructor(viewer, viewport){
		super();
		
		this.viewer = viewer;
		this.renderer = viewer.renderer;

		this.scene = null;
		this.sceneControls = new THREE.Scene();

		this.rotationSpeed = 3;  //旋转速度
         
        viewport = viewport || viewer.viewports[0]
        
        this.setCurrentViewport({hoverViewport:viewport, force:true}) //this.currentViewport = viewport
        

		this.fadeFactor = 20;
		this.yawDelta = 0;
		this.pitchDelta = 0;
		this.panDelta = new THREE.Vector2(0, 0);
		this.radiusDelta = 0;

		this.doubleClockZoomEnabled = true;

		this.tweens = [];
        this.dollyStart = new THREE.Vector2
        this.dollyEnd = new THREE.Vector2
        this.minRadius = standartMinRadius
        this.maxRadius = 300
        
        this.keys = {
            FORWARD: ['W'.charCodeAt(0), 38],
            BACKWARD: ['S'.charCodeAt(0), 40],
            LEFT: ['A'.charCodeAt(0), 37],
            RIGHT: ['D'.charCodeAt(0), 39],
            UP: ['Q'.charCodeAt(0)],
            DOWN: ['E'.charCodeAt(0)], 
        };
        
        
		let drag = (e) => {
            if(!this.enabled)return
            
            let viewport = e.dragViewport;
            if(!viewport /* || viewport.camera.type == "OrthographicCamera"  */)return
            //let camera = viewport.camera 
          


			/* if (e.drag.object !== null) {
				return;
			} */
            let mode
            
            if(e.isTouch){
               
                if(e.touches.length == 1){
                    mode = 'rotate'  
                }else{  
                    mode = 'scale-pan'
                }  
            }else{
                mode = e.buttons === Potree.defines.Buttons.LEFT ? 'rotate' : 'pan'
            }




            
			if (e.drag.startHandled === undefined) {
				e.drag.startHandled = true; 
				this.dispatchEvent({type: 'start'});
			}

			 
            let ndrag = e.drag.pointerDelta.clone()//.add(new THREE.Vector2(1,1)).multiplyScalar(0.5)
            ndrag.y *= -1

			if (mode == 'rotate') { 
                 
				this.yawDelta += ndrag.x * this.rotationSpeed;
				this.pitchDelta += ndrag.y * this.rotationSpeed;

				
			} else if(mode == 'pan'){
                if(!this.dragStarted) this.updateRadius('startPan')
				this.panDelta.x += ndrag.x;
				this.panDelta.y += ndrag.y;
                
				 
			}else if(mode == 'scale-pan'){ //add
                this.dollyEnd.subVectors(e.touches[0].pointer, e.touches[1].pointer); 
                var scale = this.dollyEnd.length() / this.dollyStart.length() 
                  
                this.dollyStart.copy(this.dollyEnd); 
                this.radiusDelta = (1-scale) * this.currentViewport.view.radius 
			  
                //------------------------
                //平移
                let pointer = new THREE.Vector2().addVectors(e.touches[0].pointer, e.touches[1].pointer).multiplyScalar(0.5);//两个指头的中心点
                 
                let delta = new THREE.Vector2().subVectors(pointer, this.lastScalePointer)
                delta.y *= -1
                this.panDelta.add(delta)
                
                this.lastScalePointer = pointer.clone()
                
                
                
                //console.log('scale ',scale, this.radiusDelta)
                
            }
            
            this.stopTweens();
            this.dragStarted = true
            
		};
        
        
        
         
        
        
		let drop = e => {
            if(!this.enabled)return
            this.dragStarted = false
			this.dispatchEvent({type: 'end'});
		};

		let scroll = (e) => {
            if(!this.enabled)return
			let resolvedRadius = this.currentViewport.view.radius + this.radiusDelta;
             
			this.radiusDelta += -e.delta * resolvedRadius * 0.1; 
             
			this.stopTweens();
            this.updateRadius('scroll')
		};

		let dblclick = (e) => {
            if(!this.enabled)return
			if(this.doubleClockZoomEnabled){
				this.zoomToLocation(e.mouse);
			}
		};

		let previousTouch = null;
		let touchStart = e => {
			previousTouch = e;
		};

		let touchEnd = e => {
			previousTouch = e;
		};

		let touchMove = e => {
            if(!this.enabled)return
			if (e.touches.length === 2 && previousTouch.touches.length === 2){
				let prev = previousTouch;
				let curr = e;

				let prevDX = prev.touches[0].pageX - prev.touches[1].pageX;
				let prevDY = prev.touches[0].pageY - prev.touches[1].pageY;
				let prevDist = Math.sqrt(prevDX * prevDX + prevDY * prevDY);

				let currDX = curr.touches[0].pageX - curr.touches[1].pageX;
				let currDY = curr.touches[0].pageY - curr.touches[1].pageY;
				let currDist = Math.sqrt(currDX * currDX + currDY * currDY);

				let delta = currDist / prevDist;
				let resolvedRadius = this.currentViewport.view.radius + this.radiusDelta;
				let newRadius = resolvedRadius / delta;
				this.radiusDelta = newRadius - resolvedRadius;

				this.stopTweens();
			}else if(e.touches.length === 3 && previousTouch.touches.length === 3){
				let prev = previousTouch;
				let curr = e;

				let prevMeanX = (prev.touches[0].pageX + prev.touches[1].pageX + prev.touches[2].pageX) / 3;
				let prevMeanY = (prev.touches[0].pageY + prev.touches[1].pageY + prev.touches[2].pageY) / 3;

				let currMeanX = (curr.touches[0].pageX + curr.touches[1].pageX + curr.touches[2].pageX) / 3;
				let currMeanY = (curr.touches[0].pageY + curr.touches[1].pageY + curr.touches[2].pageY) / 3;

				let delta = {
					x: (currMeanX - prevMeanX) / this.renderer.domElement.clientWidth,
					y: (currMeanY - prevMeanY) / this.renderer.domElement.clientHeight
				};

				this.panDelta.x += delta.x;
				this.panDelta.y += delta.y;

				this.stopTweens();
			}

			previousTouch = e;
		};

		this.addEventListener('touchstart', touchStart);
		this.addEventListener('touchend', touchEnd);
		this.addEventListener('touchmove', touchMove);
		this.viewer.addEventListener('global_drag', drag);
		this.viewer.addEventListener('global_drop', drop);
		this.viewer.addEventListener('global_mousewheel', scroll);
		this.viewer.addEventListener('global_dblclick', dblclick);
        this.viewer.addEventListener('global_touchmove', (e)=>{ 
            if(e.touches.length>1){//单指的就触发上一句 
                //console.log('global_touchmove' )
                drag(e)
            }
        });
        let prepareScale = (e)=>{//触屏的scale
            this.dollyStart.subVectors(e.touches[0].pointer, e.touches[1].pointer);
            this.lastScalePointer = new THREE.Vector2().addVectors(e.touches[0].pointer, e.touches[1].pointer).multiplyScalar(0.5);//两个指头的中心点
              
        }
         
        this.viewer.addEventListener('global_touchstart', (e)=>{
            if(this.enabled && e.touches.length==2){//只监听开头两个指头
                prepareScale(e)
            }
        })
        /* this.viewer.addEventListener('global_touchend', (e)=>{
            if(!this.enabled)return
            if(e.touches.length==1){//停止scale,开始rotate
                prepareRotate(e)
                //this.pointerDragStart = null
                //console.log('只剩一个', e.pointer.toArray())
            }
        }) */
        
        
        this.viewer.addEventListener('focusOnObject',(o)=>{
            if(o.position && o.CamTarget){
                let distance = o.position.distanceTo(o.CamTarget)
                //if(distance < minRadius) minRadius = distance * 0.5 //融合页面当focus一个很小的物体时，需要将minRadius也调小
                this.minRadius = Math.min(standartMinRadius, distance * 0.5)
                //console.log('focus dis', distance) 
            }
        })
         
	}

    

	setScene (scene) {
		this.scene = scene;
	}
    
    setCurrentViewport(o={}){//add
        if(!this.enabled && !o.force )return
        if(o.hoverViewport && this.currentViewport != o.hoverViewport ){
            this.currentViewport = o.hoverViewport  
			 
        } 
    }
    
    setEnable(enabled){
        this.enabled = enabled
    }
	stop(){
		this.yawDelta = 0;
		this.pitchDelta = 0;
		this.radiusDelta = 0;
		this.panDelta.set(0, 0);
	}
	  
    zoomToLocation(mouse){
        let I = viewer.inputHandler.intersect;
        let object  
        if(I){ 
            object = I.object || I.pointcloud;
            I = I.location
        }else{//点击空白处（地面）
            let {x,y} = Potree.Utils.getPointerPosAtHeight(0, viewer.inputHandler.pointer ) 
            I = new THREE.Vector3(x,y, 0)
        }
         
        
        let dis = this.currentViewport.view.position.distanceTo(I); 
        let distance  
         
        let object_ = object || viewer.modules.MergeEditor?.selected
        if(object_){
            distance = this.updateRadiusByModel(object_, dis)
        } 
        
        if(!object){
            if(!distance || distance < 50){ //方便从高空回到地面
                distance = Math.min(dis,50)
            } 
            this.updateRadius('focus')
        }
        
        
        viewer.focusOnObject({ position:I }, 'point', null, {distance})
        
    }
    
    
    updateRadiusByModel(object, dis=10){//鼠标到点的距离，如果没有就给个几率最大的距离
        let bound = object.boundingBox.clone().applyMatrix4(object.matrixWorld)
        let size = bound.getSize(new THREE.Vector3); 
        let len = size.length() 
        let distance = THREE.Math.clamp(dis, 0.8 * object.scale.x , Math.max(len * 0.1 , 3 * object.scale.x) );
        this.minRadius = Math.min(distance, standartMinRadius) 
        this.maxRadius = dis * 2 
        //console.log('maxRadius hasIntersect',   this.maxRadius)
        return distance
    }
    
    updateRadius(type){
        if(type == 'startPan'){//以drag的point为target, 使drag跟手
            let I = viewer.inputHandler.intersect?.location
            if(!I){
                let {x,y} = Potree.Utils.getPointerPosAtHeight(0, viewer.inputHandler.pointer ) 
                I = new THREE.Vector3(x,y, 0) //地面交点(如果没有显示地面网格很可能模型跑到地面之下怎么办，ground不再是0的高度，怎么办。主要是测试时乱放模型。)
            } 
            let vec = new THREE.Vector3().subVectors(I, this.currentViewport.view.position)
            let dis = vec.projectOnVector(this.currentViewport.view.direction).length() //要拖拽的点到镜头平面距离
              
            this.currentViewport.view.radius = dis
            //console.log('radius',dis)
        }
            
         
        
        let model = viewer.inputHandler.intersect?.object || viewer.inputHandler.intersect?.pointcloud 
        if(model){
            this.updateRadiusByModel(model, viewer.inputHandler.intersect.location.distanceTo(this.currentViewport.view.position))
             
        }else { 
            if(!viewer.bound || viewer.bound.boundSize.x == 0){
                this.maxRadius = viewer.mainViewport.view.position.length() * 2
            }else{
                let boundFloor = viewer.bound.boundingBox.clone();
                boundFloor.max.z = boundFloor.min.z
                let dis2 = boundFloor.distanceToPoint(viewer.mainViewport.view.position)  //靠近模型底部时变慢 
                this.maxRadius = Math.max(4, dis2 * 5)
                //console.log('maxRadius noIntersect', this.maxRadius)
            }
        }  
    }
    /*  增加maxRadius限制是因为2024.12有人提单说在离模型区域bound很远的地方scroll和drag多次之后回来，radius会过大。
    所以只能稍微加一个影响radius的因素。但是当没有intersect时，效果可能欠佳。
    没有完美的方法，想象下，在bound外也有物体需要focusPoint, 如path， 此时虽然离bound很远但也需要小radius。
    而当转向朝bound飞去却很慢，虽然可以根据intersect提高minRadius来加速，但如果是focus一个四周都有模型的target，就会被intersect干扰,无法focus。
    
    现在存在的现象就是容易出现radius过小，游不到终点的情况，所以我让双击可以focus地面，通过这个办法攀到终点。另外drag时修改了radius，使跟手。但若不显示地面和地图，就很奇怪。
    *没办法直接更改radius，而是通过minRadius和maxRadius, 是因为情况太多了，直接更改不能满足所有情况，还会造成突变。
    *minRadius一般不超过standardMinRadius
    */

	stopTweens () {
		this.tweens.forEach(e => e.stop());
		this.tweens = [];
	}

	update (delta) {
        if(!this.enabled)return
		let view = this.currentViewport.view//this.currentViewport.view;
        let camera = this.currentViewport.camera



        { // accelerate while input is given
			let ih = this.viewer.inputHandler;

			let moveForward = this.keys.FORWARD.some(e => ih.pressedKeys[e]);
			let moveBackward = this.keys.BACKWARD.some(e => ih.pressedKeys[e]);
			let moveLeft = this.keys.LEFT.some(e => ih.pressedKeys[e]);
			let moveRight = this.keys.RIGHT.some(e => ih.pressedKeys[e]);
			let moveUp = this.keys.UP.some(e => ih.pressedKeys[e]);
			let moveDown = this.keys.DOWN.some(e => ih.pressedKeys[e]);
            
             
            let moveSpeed = this.currentViewport.getMoveSpeed() / 20;
            let px = 0 , py = 0, pz = 0
            if(moveForward){
                py = 1 * moveSpeed 
            }else if(moveBackward){
                py = -1 * moveSpeed 
            }
            
            if(moveLeft){
                px = -1 * moveSpeed 
            }else if(moveRight){
                px = 1 * moveSpeed 
            }
            if(moveUp){
                pz = 1 * moveSpeed 
            }else if(moveDown){
                pz = -1 * moveSpeed 
            }
            
            (px!=0 || py!=0 || pz!=0) && view.translate(px, py, pz, true); 
             
        }
                
 


		{ // apply rotation
			let progression = Math.min(1, this.fadeFactor * delta);

			let yaw = view.yaw;
			let pitch = view.pitch;
			let pivot = view.getPivot();

			yaw -= progression * this.yawDelta;
			pitch -= progression * this.pitchDelta;

			view.yaw = yaw;
			view.pitch = pitch;

			let V = this.currentViewport.view.direction.multiplyScalar(-view.radius);
			let position = new THREE.Vector3().addVectors(pivot, V);

			view.position.copy(position);
		}

		if(camera.type != 'OrthographicCamera'){ // apply pan 平移 
            let panDistance = view.radius * Math.tan(THREE.Math.degToRad(camera.fov / 2));//参照4dkk  只要radius设置正确就完全跟手（见updateRadius）  
            //计算了下确实是这么算的。 平移pivot。  
            
			let px = -this.panDelta.x * panDistance * camera.aspect 
			let py = this.panDelta.y * panDistance 

			view.pan(px, py);
		}

		{ // apply zoom
			let progression = 1//Math.min(1, this.fadeFactor * delta);
             
            
            
			// let radius = view.radius + progression * this.radiusDelta * view.radius * 0.1;
			let radius = view.radius + progression * this.radiusDelta;
                      
			let V = view.direction.multiplyScalar(-radius);
			let position = new THREE.Vector3().addVectors(view.getPivot(), V);
            
			radius = Math.min(radius, this.maxRadius)
            if(this.constantlyForward) {// 到达中心点后还能继续向前移动，也就是能推进中心点 
                radius = Math.max(radius, this.minRadius)
            }
            
            
            view.radius = radius;            
			view.position.copy(position);
		}

		{
			let speed = view.radius;
			this.viewer.setMoveSpeed && this.viewer.setMoveSpeed(speed);
		}

		{ // decelerate over time
			/* let progression = Math.min(1, this.fadeFactor * delta);
			let attenuation = Math.max(0, 1 - this.fadeFactor * delta);

			this.yawDelta *= attenuation;
			this.pitchDelta *= attenuation;
			this.panDelta.multiplyScalar(attenuation);
			// this.radiusDelta *= attenuation;
			this.radiusDelta -= progression * this.radiusDelta; */
            
            //取消衰减，直接stop
            this.stop()  
		}
	}
};
